import React from 'react';

const Pagination = ({ currentPage, totalPages, onPageChange }) => {

    const generatePageNumbers = () => {
        const pages = [];

        if (totalPages <= 5) {
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
            }
        } else {
            if (currentPage <= 3) {
                pages.push(1, 2, 3, '...', totalPages);
            } else if (currentPage >= totalPages - 2) {
                pages.push(1, '...', totalPages - 2, totalPages - 1, totalPages);
            } else {
                pages.push(1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages);
            }
        }

        return pages;
    };

    const pages = generatePageNumbers();

    return (
        <div className="pagination d-flex justify-content-center my-4 flex-wrap">
    <button
        className="mx-1 btn btn-sm btn-dark"
        onClick={() => onPageChange(1)}
        disabled={currentPage === 1}
    >
        &laquo;
    </button>

    <button
        className="mx-1 btn btn-sm btn-dark"
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
    >
        &lt;
    </button>

    {pages.map((page, index) => (
        <button
            key={index}
            className={`mx-1 btn btn-sm ${page === currentPage ? 'btn-primary text-white' : 'btn-light'} ${page === '...' ? 'disabled' : ''}`}
            onClick={() => page !== '...' && onPageChange(page)}
            disabled={page === '...'}
        >
            {page}
        </button>
    ))}

    <button
        className="mx-1 btn btn-sm btn-dark"
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
    >
        &gt;
    </button>

    <button
        className="mx-1 btn btn-sm btn-dark"
        onClick={() => onPageChange(totalPages)}
        disabled={currentPage === totalPages}
    >
        &raquo;
    </button>
    <style>
        {`
        .pagination .btn-primary{
            background-color: #98ea24;
            border-color: #98ea24;
            color: #000000 !important;
        }
        .pagination .btn{
            min-width: 50px;
            height: 50px;
            padding: 0;
            border-radius: 50%;
            font-size: 18px;
        }
        `}
    </style>
</div>

    );
};

export default Pagination;
